(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvImageInput', drvImageInput);

    drvImageInput.$inject = [];
    drvImageInputCtrl.$inject = ['$scope', 'DmsService', 'uuid', 'DialogService'];

    function drvImageInput() {
        return {
            templateUrl: 'app/fieldinput/image-input.tmpl.html',
            require: ["ngModel", "fileAttachmentList"],
            scope: {
                value: '=ngModel',
                field: '=',
                fileAttachmentList: '='
            },
            controller: drvImageInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '=',
                fileAttachmentList: '='
            }
        };
    }

    function drvImageInputCtrl($scope, DmsService, uuid, DialogService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.showImage = showImage;
        drvCtrl.loading = false;
        drvCtrl.load = load;
        drvCtrl.remove = remove;
        Object.defineProperty(drvCtrl, 'invalid', {
            get: function () {
                return (!_.isNil(drvCtrl.field) && drvCtrl.field.Mandatory && (_.isNil(drvCtrl.value) || drvCtrl.value === '' || drvCtrl.value.toString().startsWith('Delete:')));
            }
        });

        var addPrefix = 'add:';
        var updatePrefix = 'update:';
        var deletePrefix = 'delete:';

        activate();

        function activate() {
            $scope.$watch(function () {
                return drvCtrl.dropFile;
            }, function () {
                if (!angular.isUndefined(drvCtrl.dropFile) && drvCtrl.dropFile !== null) {
                    load(null, drvCtrl.dropFile, null);
                }
            });

            // Only retrieve image on initial load. This has the side-effect of preventing the image being
            // re-loaded when saved.
            if (!_.isNil(drvCtrl.value) &&
                drvCtrl.value !== '' &&
                !_.startsWith(drvCtrl.value, addPrefix) &&
                !_.startsWith(drvCtrl.value, updatePrefix) &&
                !_.startsWith(drvCtrl.value, deletePrefix)) {

                drvCtrl.existingFile = true;
                drvCtrl.fileReference = drvCtrl.value;
                retrieveFile();
            }

            // If loading with an "add" or "update" prefix, this is probably in a dialog,
            // meaning the image data is already in the drvCtrl.fileAttachmentList "cache".
            // Fetch the image data from that cache.
            if (!_.isNil(drvCtrl.value) && drvCtrl.value !== '' &&
                (_.startsWith(drvCtrl.value, addPrefix) || _.startsWith(drvCtrl.value, updatePrefix))) {

                if (_.startsWith(drvCtrl.value, addPrefix)) {
                    drvCtrl.fileReference = drvCtrl.value.substr(addPrefix.length);
                } else if (_.startsWith(drvCtrl.value, updatePrefix)) {
                    drvCtrl.fileReference = drvCtrl.value.substr(updatePrefix.length);
                }

                if (!_.isNil(drvCtrl.fileReference) && drvCtrl.fileReference !== '') {
                    var file = drvCtrl.fileAttachmentList[drvCtrl.fileReference];
                    if (!_.isNil(file)) {
                        drvCtrl.imageLink = URL.createObjectURL(file);
                    }
                }
            }

            $scope.$watch('drvCtrl.value', function (newVal, oldVal) {

                // As the value is changed, it may or may not refer to an existing file. Need to update accordingly.

                if (_.isNil(newVal) || newVal === '') {
                    drvCtrl.existingFile = false;
                    drvCtrl.fileReference = uuid.v4();
                } else if (!_.startsWith(newVal, addPrefix) && !_.startsWith(newVal, updatePrefix) && !_.startsWith(newVal, deletePrefix)) {
                    drvCtrl.existingFile = true;
                    drvCtrl.fileReference = newVal;
                }
            });
        }

        /**
         * Retrieve the image file for display.
         */
        function retrieveFile() {
            drvCtrl.loading = true;

            return DmsService.retrieveFile(drvCtrl.fileReference)
                .then(retrieveFileOk, retrieveFileError);

            function retrieveFileOk(response) {
                var imageFile = new Blob([response.data]);
                drvCtrl.imageLink = URL.createObjectURL(imageFile);
                drvCtrl.loading = false;
            }

            function retrieveFileError(response) {
                DialogService.alert('The image file for ' + drvCtrl.field.Name + ' was unable to be retrieved.');
                drvCtrl.loading = false;
            }
        }

        /**
         * Should the image be shown?
         *
         * @returns {bool}
         */
        function showImage() {
            return angular.isDefined(drvCtrl.imageLink) && drvCtrl.imageLink !== null && drvCtrl.imageLink !== '';
        }

        /**
         * Load image from file.
         */
        function load(files, file, event) {
            if (angular.isDefined(file) && file !== null) {
                if (drvCtrl.existingFile) {
                    drvCtrl.value = updatePrefix + drvCtrl.fileReference;
                } else {
                    drvCtrl.value = addPrefix + drvCtrl.fileReference;
                }

                drvCtrl.fileAttachmentList[drvCtrl.fileReference] = file;
                drvCtrl.imageLink = URL.createObjectURL(file);
            }
        }

        /**
         * Remove the image.
         */
        function remove() {
            if (drvCtrl.existingFile) {
                drvCtrl.value = deletePrefix + drvCtrl.fileReference;
            } else {
                drvCtrl.value = '';
            }
            delete drvCtrl.fileAttachmentList[drvCtrl.fileReference];
            drvCtrl.imageLink = null;
        }
    }
})();